import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  hmr: false,
  apiUrl: 'https://pitch-api.qa1.gls.wmgapps.dev/api/',
  featureFlags: {},
};
